

import Detail from "@/store/modules/shipment/declarecustoms/detail";
import { Component, FormPageMixins, appConst} from "@/lib";
import CardTitleView from "@/components/card-title/index.vue"

@Component({components: { CardTitleView}})
export default class DetailView extends FormPageMixins  {
  model = new Detail();
  loading:boolean = false;

  config: any = {
        model: new Detail(),
        getAction: "shipment/declarecustoms/getData",
        isHideOk: true,
       
  }

  setSizeUnit(unit) {
    return unit === this.$appconst.unit.size;
  }
  setdotNumber(isSizeUnit) {
    return isSizeUnit ? 2 : 0;
  }

  quantity(row) {
    let dotNumber = this.setdotNumber(this.setSizeUnit(row.unit));
    return !!row.quantity || row.quantity === 0 ? row.quantity.toFixed(dotNumber) : row.quantity
  }

  get record() {
      return this.$store.state["shipment"]["declarecustoms"].detailData;
  }

  async created() {

  }

  get column() {
    return [
      this.$util.render.baseColumn("app.SystemCode.SequenceNo", 80, {key: "rowIndex", align: 'center'}),
      this.$util.render.baseColumn("app.DeclareGroup.ProductName", null, {key: "productName", slot: "productName", align: 'left',minWidth:300}),
      this.$util.render.baseColumn("app.DeclareGroup.BoxCount", null, {key: "boxCount", align: 'center',minWidth:120}),
      this.$util.render.baseColumn("app.DeclareGroup.Quantity", null, {slot: "quantity", key: "quantity", align: 'center',minWidth:120}),
      this.$util.render.codeColumn("app.DeclareGroup.Unit", "unit", () => this.getCodeListByCategory(appConst.codeCategory.unit), {key: "unit", align: 'center',minWidth:120}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalGrossWeight", null, {key: "totalGrossWeight", align: 'center',minWidth:120, render: (h: any, params: any) => {
        return [h("span", !!params.row.totalGrossWeight || params.row.totalGrossWeight === 0 ? params.row.totalGrossWeight.toFixed(2) : "")];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalNetWeight", null, {key: "totalNetWeight", align: 'center',minWidth:120, render: (h: any, params: any) => {
        return [h("span", !!params.row.totalNetWeight || params.row.totalNetWeight === 0 ? params.row.totalNetWeight.toFixed(2) : "")];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.Price", null, {key: "price", align: 'center', minWidth: 100, render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.price))];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalAmount", null, {key: "totalAmount", align: 'center', minWidth: 120, render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.totalAmount))];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.ProductCode", null, {key: "productCode", align: 'center',minWidth:120}),
      this.$util.render.baseColumn("app.Factory.FactoryName", null, {key: "factoryName", width: 108}),
      this.$util.render.baseColumn("app.DeclareCustoms.DomesticSourceOfGood", null, {key: "domesticSourceOfGood", width: 108}),
    ];
  }
      back() {
     this.$router.push({ name: "declarecustoms.list" });
  }  
  handleSpan ({ row, columnIndex }) {
    if (columnIndex == 0) {
      return {
          rowspan: row.rowspan,
          colspan: 1
      };
    }
  }

  handleSummary ({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.Common.Total');
    const NA = '';
    columns.forEach((column, index) => {
        const key = column.key ? column.key : column.slot;
        if (index === 0 || index === 4 || index === 7 || index === 9 || index === 10) {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        if (index === 1) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        let haveSizeUnit = (data as Array<any>).some((item)=> {
          return this.setSizeUnit(item.unit);
        });
        let dotNumber = this.setdotNumber(haveSizeUnit);
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
            }, 0);
            let amountText = "";
            switch(key) {
              case "totalAmount": 
                amountText = this.$util.format.amount(v);
                break;
              case "boxCount":
                amountText = v.toFixed(0);
                break;
              case "quantity":
                amountText = v.toFixed(dotNumber);
                break;
              default:
                amountText = v.toFixed(2);
                break;
            }
            sums[key] = {
                key,
                value: amountText
            };
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }

  get shipmentList() {
    let list = [];
    if (!!this.model.productList && this.model.productList.length > 0) {
      const poNumberText = this.L('app.DeclareGroup.PoNumber');
      this.model.productList.forEach((item, index) => {
        // 当PO#和总品名都没有填写，则Talbe中不增加组名行
        let hasGroup = false;
        let childLength = item.productList.length;
        if (!!item.poNumber || !!item.groupName) {
          list.push({
            rowspan: childLength + 1,
            isGroup: true,
            isTitle: true,
            dataIndex: index,// 序号
            rowIndex: index + 1,// 显示的序号
            poNumber: !!item.poNumber ? `${poNumberText}${item.poNumber}` : "",
            groupName: item.groupName
          })
          hasGroup = true;
        }
        
        item.productList.forEach((productItem, productItemIndex) => {
          list.push({
            rowspan: hasGroup || productItemIndex !== 0 ? 0 : childLength,
            isGroup: false,
            isTitle: !hasGroup,
            dataIndex: index,// 序号
            rowIndex: index + 1,// 显示的序号
            productName: `${productItem.productNameEn}/${productItem.productName}`,
            quantity: productItem.quantity,
            unit:productItem.unit,
            boxCount: productItem.boxCount,
            totalGrossWeight: productItem.totalGrossWeight,
            totalNetWeight: productItem.totalNetWeight,
            price: productItem.price,
            totalAmount: productItem.totalAmount,
            productCode: productItem.productCode,
            factoryId: productItem.factoryId,
            factoryName: productItem.factoryName,
            domesticSourceOfGood: productItem.domesticSourceOfGood
          })
        })
      })
    };
    return list;
  }

  get boxList() {
    let list = [];
    if (!!this.model.customsBoxList && this.model.customsBoxList.length > 0) {
      this.model.customsBoxList.forEach((item, index) => {
        list.push({
            rowIndex: index + 1,// 显示的序号
            boxType: item.boxType,
            boxQuantity: item.boxQuantity,
            logisticsName:item.logisticsName
        })
      })
    };
    return list;
  }

  rowClassName (row, index) {
    if (row.isTitle) {
      return 'hi-table-group-row';
    }
    return '';
  }

  formatTotalVolume(value: string): string {
    if (!value && value !== '0') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    const fixed = num.toFixed(3);
    return fixed.endsWith('0') ? num.toFixed(2) : fixed;
  }
}
